// `filter` values accepted by GET /admin/users (frontend-only UI enumeration).
export const ADMIN_USERS_FILTERS = {
  ALL: 'all',
  UNVERIFIED: 'unverified',
  PENDING: 'pending',
  BLOCKED: 'blocked',
} as const;

export type AdminUsersFilter = typeof ADMIN_USERS_FILTERS[keyof typeof ADMIN_USERS_FILTERS];

// Single display status of an admin user row (derived from account_status + email_verified).
export const ADMIN_USER_DISPLAY_STATUSES = {
  BLOCKED: 'blocked',
  PENDING: 'pending',
  UNVERIFIED: 'unverified',
  ACTIVE: 'active',
} as const;

export type AdminUserDisplayStatus =
  typeof ADMIN_USER_DISPLAY_STATUSES[keyof typeof ADMIN_USER_DISPLAY_STATUSES];
